/* eslint-disable prettier/prettier */
export default {
  label: {
    ok: 'ஒகே',
    confirm: 'உறுதி',
    cancel: 'ரத்து செய்',
    download: 'டவுன்லோட்',
    submit: 'சமர்ப்பிக்க',
    search: 'தேடு',
    recharge: 'ரீசார்ஜ்',
    balance: 'பேலன்ஸ்',
  },
  tip: {
    success: 'வெற்றிகரமாக',
  },
  text: {},
  defaultPage: {
    noMore: 'மேலும் டேட்டா இல்லை',
  },
  home: {
    scratchOff: 'ஸ்கிராட்ச் ஆஃப்',
    copied:
      'வெற்றிகரமாக காப்பி செய்யப்பட்டது , நண்பர்களுடன் பகிர்ந்து கொள்ளவும்',
    tip: {
      beforDownload: 'ரெஜிஸ்டர் அல்லது லோகின்',
    },
  },
  alert: {
    logout: 'வெளியேறு',
    sureLogout: 'நீங்கள் நிச்சயமாக வெளியேற விரும்புகிறீர்களா?',
  },
  warning: {
    unopen: 'திறக்கப்படாது',
  },
  notification: {
    title: 'அறிவிப்புகள்',
    announcements: 'அறிவிப்புகள்:',
    systemMessage: 'சிஸ்டம் செய்திகள்',
  },
  vip: {
    currentLevel: 'தற்போதைய நிலை',
    collected: 'பெற்றுக்கொள்ளுங்கள்',
    finished: 'முடிவடைந்தது',
    received: 'பெறப்பட்டது',
    recharge: 'ரீசார்ஜ்',
    move: 'நிலை அடைய',
    title: 'விஐபி',
    table: {
      level: 'விஐபி லெவல்',
      reward: 'ரிவார்ட்',
      bouns: 'போனஸ்',
      spin: 'ஸ்பின்',
    },
    label: {
      reward: 'விஐபி நிலை வெகுமதிகள்',
      weekCard: 'வாராந்திர அட்டை',
      weekReward: 'வாராந்திர VIP வெகுமதி',
      withdrawAmount: 'திரும்பப் பெறும் தொகை',
      withdrawTimes: 'திரும்பப் பெறும் நேரங்கள்',
      withdrawFee: 'திரும்பப் பெறும் கட்டணம்',
      silverWeekCard: 'வெள்ளி வாராந்திர கார்டு',
      goldWeekCard: 'தங்க வாராந்திர கார்டு',
      diamondWeekCard: 'வைர வாராந்திர கார்டு',
      day: 'நாள்',
      rewardDetails: 'வெகுமதி விவரங்கள்',
      rewardAccumulation: 'வெகுமதி குவிப்பு',
      vipUpgrade: 'VIP மேம்பாடு',
      buyWeekCard: 'வாராந்திர அட்டை வாங்கும் உரிமை',
      weekCardRecharge: 'வாராந்திர கார்டு ரீசார்ஜ்',
      weekCardBuyRecord: 'வாராந்திர அட்டை கொள்முதல் பதிவு',
    },
    tip: {
      levelDetail: {
        t01: 'VIP நிலை வெகுமதி',
        p1: 'VIP நிலை <0>{{level}}</0>-ஐ அடையுங்கள், ஒரு முறை வெகுமதி பெறுங்கள்',
        t02: 'வாராந்திர VIP வெகுமதி',
        p2: 'VIP நிலை <0>{{level}}</0>-ஐ அடையுங்கள், வாராந்திர அடிப்படை வெகுமதிகள் <0>{{money}}</0> பெறுங்கள். ரீசார்ஜ் , பெட்டிங் மற்றும் செயலில் இருப்பதன் மூலம் வெகுமதி பெறுவதை அதிகரிக்கலாம்.',
        t03: 'VIP பணம் எடுத்தல்',
        p3: 'VIP நிலை <0>{{level}}</0>-இல், ஒரு முறை பணம் எடுக்கும் தொகை <0>{{money}}</0> வரை இருக்கும்.',
        t04: 'VIP பணம் எடுத்தல் அளவு',
        p4: 'VIP நிலை <0>{{level}}</0>-இல், ஒரு நாளைக்கு <0>{{count}}</0> முறை பணம் எடுக்கலாம்.',
        t05: 'VIP பணம் எடுத்தல் கட்டணம்',
        p5: 'VIP நிலை <0>{{level}}</0>-இல், ஒரு பரிவர்த்தனைக்கு கட்டணம் <0>{{money}}</0> ஆகக் குறைவாக இருக்கும்.',
      },
      remainTime: 'வாராந்திர அட்டையின் மீதமுள்ள வைத்திருக்கும் நேரம்:',
      remainTimeBottom:
        'வாராந்திர அட்டை வெகுமதிகள் வாங்கிய நாளிலிருந்து அடுத்த நாள் வரை விதிக்கப்படும்.',
      upgrade: {
        to: 'எங்கள் மதிப்புமிக்க VIP-களுக்கு:',
        subtitle:
          ' உங்கள் தொடர்ச்சியான ஆதரவு எங்களை முன்னோக்கி கொண்டு செல்கிறது! இந்த அமைப்பு மேம்பாட்டுடன், நீங்கள் பெறுவது:',
        li1: 'மென்மையான பிரத்தியேக சேவைகள்',
        li2: 'புதிய VIP அம்சங்கள்',
        li3: 'எங்கள் நன்றியின் அடையாளமாக, உங்களுக்கு சிறப்பு மேம்பாடு பரிசு தொகுப்பு!',
      },
      weekCardReward: {
        title: 'வாராந்திர கார்டு வெகுமதிகள்',
        p1: 'வாராந்திர கார்டு வைத்திருக்கும் போது குவிக்கப்பட்ட வெகுமதிகள்.',
        p2: '(குறிப்பு: தினமும் ஆப்-ல் லாகின் செய்ய  வேண்டும், தவறிய நாட்களுக்கு வெகுமதி கிடைக்காது.)',
      },
      weekCard: {
        p1: 'இப்போது ரீசார்ஜ் செய்யுங்கள், உடனடியாக <0>{{money}}</0> பெறுங்கள்',
        p2: 'கூடுதல் தினசரி போனஸ்கள்:',
        p3: 'மொத்த மதிப்பு: <0>{{money}}</0>',
      },
      weekReward: {
        t1: 'உங்கள் வாராந்திர VIP வெகுமதிகள் இதோ',
        t2: 'வெகுமதிகளை எப்படி அதிகரிப்பது?',
        p1: 'கடந்த வாரத்தில் ஆப்-ல் உங்கள் செயல்பாட்டைப் பொறுத்து VIP வெகுமதிகள் அமையும். ரீசார்ஜ், பெட்டிங் மற்றும் ஈடுபாடு உங்கள் பெருக்கத்தை அதிகரிக்கும்.',
        p2: 'ஒவ்வொரு பயனரும் <0>{{money}}</0>-க்கு மேல் வெகுமதிகள் பெற வாய்ப்பு உள்ளது!',
        yourReward: 'கடந்த வாரத்தின் உங்கள் வெகுமதி',
      },
      weeklyRemain: 'உங்கள் வாராந்திர அட்டையில் மீதமுள்ள தொகை',
      confirmBuyTitle: 'வாராந்திர அட்டையை வாங்கவும்',
      confirmBuy: '{{type}} வாராந்திர அட்டையை வாங்குவதை உறுதிசெய்யவா?',
      weekCardBuySuccess: '{{type}} வாராந்திர அட்டையை வெற்றிகரமாக வாங்கவும்.',
      noVip:
        'வாராந்திர அட்டை VIP பயனர்கள் மட்டுமே வாங்குவதை ஆதரிக்கிறது, தயவுசெய்து மேம்படுத்தவும்.',
    },
    rules: {
      title: 'VIP வாராந்திர கார்டு பயன்பாட்டு விதிகள்',
      subtitle1: 'VIP வாராந்திர கார்டு என்றால் என்ன?',
      sub1paragraph1:
        'பிரத்தியேக சலுகை: VIP>=4 பயனர்களுக்கு மட்டுமே, வாங்கியவுடன் உடனடியாக செயல்படும்.',
      sub1paragraph2:
        'செல்லுபடியாகும் காலம்: 7 நாட்கள் (நீட்டிக்கப்படலாம்)',
      subtitle2: 'இரட்டை வெகுமதி',
      sub2paragraph1:
        'ரீசார்ஜ் தொகைக்கு சமமான மதிப்பு (எ.கா., 30 ரூபாய் ரீசார்ஜ் செய்தால் 30 புள்ளிகள்).',
      sub2paragraph2:
        'செல்லுபடியாகும் காலம்: ஒவ்வொரு வாராந்திர அட்டையும் 7 இயற்கை நாட்களுக்கு நீடிக்கும் (நீட்டிக்கப்படலாம்)',
      subtitle3: 'வெகுமதி பெறுதல்',
      buyTip:
        'வாங்கிய நாளில், நீங்கள் ரீசார்ஜ் சமமான தொகையைப் பெறுவீர்கள், வாராந்திர அட்டை வெகுமதிகள் அடுத்த நாள் வரை விதரப்படும்.',
      sub3paragraph1:
        'தினமும் ஆப்-ல்  லாகின் செய்ய வேண்டும், இல்லையெனில் வெகுமதி அடுத்த நாளுக்கு தள்ளிவைக்கப்படும்.',
      sub3paragraph2:
        'காலாவதியான பிறகு வெகுமதிகள் செல்லாது.',
      subtitle4: 'மேல்நோக்கு சலுகைகள்',
      sub4paragraph1: 'ஒரே வகையான வாராந்திர கார்டுகள் ஒன்றுக்கு மட்டுமே வைக்கலாம்',
      sub4paragraph2:
        'பல வகையான வாராந்திர கார்டுகள்: ஒரே நேரத்தில் 3 வகையான வாராந்திர கார்டுகளை செயல்படுத்தலாம்',
      subtitle5: 'VIP பிரத்தியேகம்',
      sub5paragraph1:
        'VIP பயனர்கள் மட்டுமே இதை வாங்க/பார்க்க முடியும், VIP இல்லாதவர்களுக்கு இது கிடைக்காது.',
      sub5paragraph2:
        'திங்களன்று [தங்க வாராந்திர கார்டு] வாங்கினால், அடுத்த திங்கள் வரை தினமும் தங்க வெகுமதிகள் கிடைக்கும்.',
      sub5paragraph3:
        'வெள்ளியன்று மீண்டும் அதே கார்டுயை வாங்கினால், செல்லுபடியாகும் காலம் அடுத்த ஞாயிறு வரை நீட்டிக்கப்படும்.',
      sub5remark1:
        'பரிந்துரை: தினமும் ஆப்-ல்  லாகின் செய்து வெகுமதிகளைப் பெறுங்கள்!',
      sub5remark2: 'சந்தேகங்கள்  இருந்தால், வாடிக்கையாளர் சேவையைத் தொடர்பு கொள்ளவும்.',
    },
    success: 'வெற்றிகரமாகப் பெறப்பட்டது',
    rechargeTip: 'நிலை {{level}} ஐ அடைய <0>{{price}}</0> ரீசார்ஜ் செய்யவும்.',
    incoming: 'இந்த நிலையை அடைந்த பிறகு, மறைக்கப்பட்ட நிலை திறக்கப்படும்.',
  },
  referral: {
    copy: 'காப்பி',
    invite: 'இன்வைட்',
    copied: 'வெற்றிகரமாக காப்பி செய்யப்பட்டது',
  },
  luckyspin: {
    add: 'ஆட்',
    spin: 'ஸ்பின்',
    won: 'வின்',
    winner: 'பிக் வின்னர்',
    mySpin: 'மை ஸ்பின்',
    free: 'ஃப்ரீ',
    myfree: 'மை ஃப்ரீ',
    morefree: 'மோர் ஃப்ரீ',
    vip: 'விஐபி ',
    usefreefirst: 'யூஸ் அப்ஃப்ரீ டைம் பஸ்ட்டு',
  },
  'error-pages': {
    refresh: {
      label: {
        title: 'ஏதோ பிழையாகிவிட்டது!',
        'sub-title': 'தயவுசெய்து உங்கள் பக்கத்தைப் புதுப்பிக்கவும்',
        'try-again': 'மீண்டும் முயற்சிக்கவும்',
      },
    },
    'no-data': {
      label: {
        title: 'டேட்டா எதுவும் இல்லை',
      },
    },
    'not-found': {
      label: {
        title: 'தற்போதைய நெட்வொர்க் சிக்னல் மோசமாக உள்ளது',
        'sub-title': 'நெட்வொர்க் சிக்னலைசரிபார்க்கவும் ',
      },
    },
    'no-result': {
      label: {
        title: 'தேடல் ரிசல்ட் இல்லை!',
      },
    },
  },
  share: {
    copy: 'காப்பி',
    invite: 'இன்வைட்',
    'copy-success': 'வெற்றிகரமாக காப்பி செய்யப்பட்டது',
    copied: 'வெற்றிகரமாக காப்பி செய்யப்பட்டது',
  },
  casino: {
    big: 'பிக்',
    win: 'வின்',
    detail: {
      title: 'அதிர்ஷ்டசாலி வீரர்களுக்கு வாழ்த்துக்கள்',
    },
    winPrize: 'வின் பிரைஸ்',
    playnow: 'இப்பொழுதே விளையாடு',
  },
  login: {
    label: {
      login: 'உள்நுழைய',
      skip: 'தவிர்க்கவும்',
      sign: 'பதிவு செய்யவும்',
      next: 'அடுத்தது',
      'select-region': 'பிராந்தியத்தைத் தேர்ந்தெடுக்கவும்',
      'otp-login': 'OTP உள்நுழைவு',
      'password-login': 'பாஸ்வர்ட் உள்நுழைவு',
      'get-otp': 'OTP பெறுக',
      'set-password': 'பாஸ்வர்ட் அமைக்கவும் ',
    },
    tip: {
      'no-phone': 'தொலைபேசி எண்ணை உள்ளிடவும்',
      'no-password': 'பாஸ்வர்ட் உள்ளிடவும்',
      'no-otp': 'OTP உள்ளிடவும்',
      phone: 'தொலைபேசி எண்ணை உள்ளிடவும்',
      password: 'பாஸ்வர்ட் உள்ளிடவும்(6-18)',
      passwordRule:
        'பாஸ்வர்ட் 8~16 ஆக இருக்க வேண்டும் மற்றும் எண்கள் மற்றும் எழுத்துக்கள் இரண்டையும் கொண்டிருக்க வேண்டும்',
      'confirm-password': 'பாஸ்வர்ட் உறுதிப்படுத்தவும்',
      forgot: 'பாஸ்வர்டை மறந்து விட்டீர்களா?',
      'new-account': 'கணக்கு வேண்டும்?',
      'sing-in': 'பதிவு செய்யவும்',
      otp: 'OTP ஐ உள்ளிடவும்',
      'referral-code': 'ரெபரல் கோர்ட',
      confrim18: 'நான் 18+ என்று உறுதி செய்கிறேன்+',
      'allow-notify':
        'இந்த ஃபோனின் எண் மூலம் முக்கியமான வெற்றிகரமான தகவலை உங்களுக்குத் தெரிவிக்க எங்களை அனுமதிக்கவும்.',
      'has-account': 'ஏற்கனவே ஒரு பயனர்?',
      'sign-in': 'உள்நுழைய',
      page18: 'நான் 18+ என்று உறுதி செய்கிறேன்',
      notify:
        'இந்த ஃபோனின் எண் மூலம் முக்கியமான வெற்றிகரமான தகவலை உங்களுக்குத் தெரிவிக்க எங்களை அனுமதிக்கவும் .',
      'pwd-dif': 'இழுவை பாஸ்வர்டை சரிபார்க்கவும்',
      modified: 'பாஸ்வர்ட் வெற்றிகரமாக மாற்றப்பட்டது. மீண்டும் உள்நுழையவும்',
      'game-not-active':
        'மன்னிக்கவும், கேம் இப்பொழுது பராமரிப்பில் உள்ளது. தயவுசெய்து  பிறகு முயற்சிக்கவும்',
    },
  },
  paidSuccess: {
    label: {
      title: 'கட்டணம்',
      subTitle: 'வெற்றிகரமாக செலுத்தப்பட்டது',
      viewOrder: 'ஆர்டர்களைப் பார்க்கவும்',
      backHome: 'மீண்டும் திரும்பு',
    },
    tip: {
      msg: 'உங்கள் டிக்கெட்டுகள் வெற்றிகரமாக வாங்கப்பட்டன. டிரா நேரத்தைக் கவனத்தில் கொள்ளவும், முடிவுகளை உடனடியாகச் சரிபார்க்கவும்.',
    },
  },
  splash: {
    tip: {
      checkingResources: 'ஆதாரங்களைச் சரிபார்க்கிறது...',
      checkingVersion: 'பதிப்பைச் சரிபார்க்கிறது...',
      downloading: 'வளர்ச்சியை பதிவிறக்குகின்றது...',
      resolv:
        'ஆதாரங்களைத் தீர்ப்பது (இந்த செயல்முறை நெட்வொர்க்கைப் பயன்படுத்தாது)',
      alertTitle: 'அப்டேட் தயாராகவுள்ளது',
      restart: 'ரீஸ்டார்ட்',
      alertContent:
        'அப்டேட் தயாராகவுள்ளது.ஆப்-ஐ ரீஸ்டார்ட் செய்வதன் மூலம் அப்டேட் -ஐ பெறுங்கள்...',
    },
  },
  recharge: {
    tip: {
      easyPaymentError:
        'சேவையைப் பெறுவதில் தோல்வியானால், பிற பேமேன்ட் முறைகளை பயன்படுத்தவும்',
    },
  },
  'recharge-page': {
    currentMethod: 'தற்போதைய முறை',
    label: {
      records: 'பதிவுகள்',
      min: 'குறைந்தபட்சம்',
      max: 'அதிகபட்சம்',
      channel: 'ரிசார்ஜ் சேனல்',
      enter: 'ரிசார்ஜ் அமௌன்ட் உள்ளிடவும்',
    },
    tip: {
      payMethodTip:
        'தற்போதைய முறை செயல்படவில்லையெனில் ,மாற்று முறையை பயன்படுத்தவும் .',
      'money-error': 'சரியான தொகை உள்ளிடவும்',
      'paymethod-error': 'கட்டண முறையைத் தேர்ந்தெடுங்கள்',
    },
  },
  datePicker: {
    label: {
      select: 'தேதியைத் தேர்வுசெய்க',
    },
  },
  rebate: {
    tabs: {
      all: 'அனைத்தும்',
      finish: 'முடிக்க வேண்டும்',
      collect: 'கலெக்ட் செய்ய வேண்டும்',
      received: 'பெறப்பட்டது',
    },
    title: 'ரிபேட் ',
    filter: 'பிஹில்டெர் ',
    undone: 'செயல்தவிர்க்கப்பட்டது',
    unclaimed: 'உரிமை கோரப்படவில்லை',
    completed: 'முடிந்தது',
    unfinished: 'முடிக்கப்படவில்லை',
    receive: 'பெறப்பட்டது',
    received: 'பெறப்பட்டது',
    today: 'இன்று',
    yesterday: 'நேற்று',
    betting: 'மதிப்பிடப்பட்ட பேட்டிங்:',
    rebate: 'மதிப்பிடப்பட்ட ரிபேட்:',
    congratulations: 'வாழ்த்துகள்！',
    'get-bonus': 'போனஸைப் பெறுங்கள்',
    rule: {
      betting: 'பந்தய போனஸ்:',
      'betting-detail':
        '{{name}} பந்தயத் தொகைக்கு ஏற்ப பயனர்களுக்குத் தள்ளுபடி செய்யும். நீங்கள் எவ்வளவு அதிகமாக பந்தயம் கட்டுகிறீர்களோ, அவ்வளவு அதிகமாக உங்களுக்கு கிடைக்கும்',
      activity: 'செயல் விளக்கம்:',
      'activity-detail':
        '{{name}} சூப்பர் போனஸ் தள்ளுபடி செயல்பாடு உங்களுக்காக திறந்திருக்கும். ஒவ்வொரு பந்தயத்திற்கும் தள்ளுபடி போனஸ் கிடைக்கும். நீங்கள் வென்றாலும் அல்லது தோற்றாலும் பரவாயில்லை, உங்களுக்கு தினசரி போனஸ் கிடைக்கும்.',
      actrule: 'செயல்பாட்டு விதிகள்:',
      'actrule-detail':
        'அடுத்த நாள் 00:30 மணிக்குப் பிறகு, பந்தய தள்ளுபடி போனஸ் டெய்லிபோனஸ் க்ளெய்ம் நேரம்',
      precaution: 'முன்னெச்சரிக்கை நடவடிக்கைகள்:',
      'precaution-detail-1':
        '-தகுதிவாய்ந்த {{name}} உறுப்பினர்கள் மட்டுமே நடவடிக்கைகளில் பங்கேற்க முடியும்.',
      'precaution-detail-2':
        '-ஒரே தொலைபேசி எண், வங்கி கணக்கு எண். மின்னஞ்சல் முகவரி மற்றும் ஐபி முகவரியை பல கணக்குகளுக்கு பயன்படுத்த முடியாது',
      'precaution-detail-3':
        '-{{name}} போனஸைப் பயன்படுத்தி தனிநபர்கள் அல்லது குழுக்கள் செய்த சட்டவிரோத/மோசடி நடவடிக்கைகள் கண்டறியப்பட்டால் கணக்குகளை முடக்கவோ அல்லது பணம் செலுத்துவதை ரத்துசெய்யவோ உரிமை உண்டு',
    },
  },
  wallet: {
    title: 'மை வாலட்',
    total: 'டோடல் வாலட்',
    recharge: 'ரிசார்ஜ்',
    main: 'மெயின் வாலட்',
    third: '3 வது பார்ட்டி வாலட்',
    transfer: "மாற்றம் நிறைவடைந்தது'ர்",
    translation: 'Translation: {{second}}s',
    transComplete: 'Conversion completed',
    transferNav: {
      recharge: 'ரிசார்ஜ்',
      withdraw: 'வித்த்ரா',
      transfer: 'ட்ரான்ஸ்ஃபர்',
    },
  },
  promotion: {
    title: 'விளம்பரங்கள்',
    go: 'கோ ',
    playNow: 'ப்ளே நாவ்',
    view: 'காண்க',
    detail: 'செயல்பாட்டின் விவரங்கள்',
    join: 'சேரு',
    checkin: 'சரிபார்த்தல்',
    checkinDescription: 'நிறைய ரிவார்டுகளைப் பெற தினமும் செக் இன் செய்யுங்கள்',
  },
  satta: {
    title: {
      betting: 'பேட்டிங்',
      rule: 'விதிகள்',
      history: 'ரிசல்ட் ஹிஸ்டரி',
      order: ' மை ஆர்டர்',
      panel: 'பேனல் :',
      open: 'திற',
      close: 'மூடு',
    },
    betting: {
      ank: 'அங்க்',
      jodi: 'ஜோடி',
      sp: 'SP',
      dp: 'DP',
      tp: 'TP',
      half: 'ஹாப் சங்கம்',
      full: 'ப்ஹுல் சங்கம்',
      exwinning: 'எதிர்பார்த்த வெற்றி:',
      open: 'திற',
      close: 'மூடு',
      paynow: 'இப்போது செலுத்த',
      add: 'ஆட்',
      mybids: 'மை பிட்ஸ்',
      bids: 'பிட்ஸ்',
      tip: {
        enter: {
          amount: 'வாங்கும் தொகையை உள்ளிடவும்',
          open: 'ஓப்பன் டிஜிட்டை உள்ளிடவும்',
          opens: 'ஓப்பன் டிஜிட்டை உள்ளிடவும்',
          close: 'மூடு டிஜிட்டை உள்ளிடவும்',
          closes: 'மூடு டிஜிட்டை உள்ளிடவும்',
          jodi: 'ஜோடி எண்களை உள்ளிடவும்',
          openpanna: 'ஓபன் பண்ண உள்ளிடவும்',
          closepanna: 'மூடு பன்னாவை உள்ளிடவும்',
        },
        require: {
          amount: 'வாங்கும் தொகையை உள்ளிடவும்',
          open: 'தயவு செய்து ஓபன் டிஜிட்டை உள்ளிடவும்',
          opens: 'தயவுசெய்து திறந்த டிக்கட்டை உள்ளிடவும்',
          close: 'தயவுசெய்து மூடு டிஜிட்டை உள்ளிடவும்',
          closes: 'தயவுசெய்து மூடு டிஜிட்டை உள்ளிடவும்',
          jodi: 'தயவு செய்து ஜோடி டிஜிட்டை உள்ளிடவும்',
          openpanna: 'ஓபன் பண்ணாவை உள்ளிடவும்',
          closepanna: 'மூடு பன்னாவை உள்ளிடவும்',
        },
        check: 'முடிக்கப்பட்டட டிஜிட்டை  உள்ளிடவும்',
        minAmount: 'குறைந்தபட்ச தொகை {{amount}}',
      },
      digitTitle: {
        ank: 'சிங்கிள் டிஜிட்:',
        jodi: 'ஜோடி டிஜிட்:',
        sp: 'சிங்கிள் பட்டி:',
        dp: 'டபுள் பட்டி:',
        tp: 'டிரிபிள் பட்டி:',
        half: 'HS:',
        full: 'FS:',
      },
      describe: {
        ank: 'திற அல்லது மூடு என்பதைக் கிளிக் செய்து, 1 போன்ற உள்ளீட்டுப் பெட்டியில் நீங்கள் விரும்பும் டிஜிட்டை  உள்ளிடவும்',
        jodi: '12 போன்ற உள்ளீட்டு பெட்டியில் நீங்கள் பந்தயம் கட்ட விரும்பும் இரண்டு இலக்க எண்ணை உள்ளிடவும்',
        sp: 'திற அல்லது மூடு என்பதைக் கிளிக் செய்து, 123 போன்ற உள்ளீட்டுப் பெட்டியில் நீங்கள் பந்தயம் கட்ட விரும்பும் மூன்று எண்களை உள்ளிடவும்.',
        dp: 'திற அல்லது மூடு என்பதைக் கிளிக் செய்து, உள்ளீட்டுப் பெட்டியில் பந்தயம் கட்ட விரும்பும் மூன்று எண்களை உள்ளிடவும், 112 போன்ற இரண்டு எண்கள் இருக்க வேண்டும்.',
        tp: 'திற அல்லது மூடு என்பதைக் கிளிக் செய்து, 111 போன்ற மூன்று எண்களை உள்ளிடவும்',
        half: 'திற அல்லது மூடு என்பதைக் கிளிக் செய்து, 123 மற்றும் 1,1 மற்றும் 123 போன்ற உள்ளீட்டுப் பெட்டியில் மூன்று அல்லது ஒரு எண்ணை உள்ளிடவும்.',
        full: '123 மற்றும் 123 போன்ற இரண்டு உள்ளீட்டுப் பெட்டிகளில் மூன்று இலக்கங்களை உள்ளிடவும்',
      },
    },
  },
  proxy: {
    'agent-rules': 'ஏஜென்ட் விதிகள்',
    user: {
      contact: 'இப்போது தொடர்பு கொள்ளுங்கள்',
    },
    'new-user': {
      error: 'இன்னும் புதிய பயனர்கள் இல்லை! \nமேலும் கமிஷன் சம்பாதிக்க உங்கள் நண்பர்களை அழைக்கவும்.',
    },
  },
};
